import React, { type FunctionComponent } from 'react'
import { Alert, borderRadius, colors, spacing } from '@retailer-platform/shared-components'
import { Input } from '../../shared-styled-components/SharedStyledComponents.tsx'
import { Property, PropertySection, PropertyTitle } from '../../../utils/common.styles.tsx'
import { useDomainMessages } from '../../../utils/domain/intl.ts'

interface Props {
  featureValue?: string
  onChange: (value: string) => void
}

export const QualityAuditWorkflowConfigColumnModalFeatureInputPAndR: FunctionComponent<
  React.PropsWithChildren<Props>
> = ({ featureValue, onChange }) => {
  const i18n = useDomainMessages({
    warning: 'catalogAdminDomain.qualityAuditWorkflows.configs.feature.modal.pandr.warning',
    generatedName:
      'catalogAdminDomain.qualityAuditWorkflows.configs.feature.modal.pandr.generatedName.label',
    expectedName:
      'catalogAdminDomain.qualityAuditWorkflows.configs.feature.modal.pandr.expectedName.label',
  })

  let payload: {
    expected_value_component_name?: string
    generated_value_component_name?: string
  } = {}
  try {
    payload = JSON.parse(featureValue ?? '')
  } catch (e) {
    // ignore, user will correct the input.
  }
  return (
    <PropertySection
      style={{
        gap: `${spacing.X16}`,
        border: `1px dashed ${colors.GRAYSCALE.X30}`,
        padding: `${spacing.X20}`,
        borderRadius: borderRadius.X8,
      }}
    >
      <Alert variant={'warning'}>{i18n.warning}</Alert>
      <Property style={{ flex: 1, padding: 0 }}>
        <PropertyTitle>{i18n.expectedName}</PropertyTitle>
        <Input
          onChange={e => {
            const value = e.target.value
            onChange(
              JSON.stringify({
                ...payload,
                // eslint-disable-next-line @typescript-eslint/naming-convention
                expected_value_component_name: value,
              })
            )
          }}
          value={payload?.expected_value_component_name}
        />
      </Property>
      <Property style={{ flex: 1, padding: 0 }}>
        <PropertyTitle>{i18n.generatedName}</PropertyTitle>
        <Input
          onChange={e => {
            const value = e.target.value
            onChange(
              JSON.stringify({
                ...payload,
                // eslint-disable-next-line @typescript-eslint/naming-convention
                generated_value_component_name: value,
              })
            )
          }}
          value={payload?.generated_value_component_name}
        />
      </Property>
    </PropertySection>
  )
}
